export default "__VITE_ASSET__5d3d06c5__"